import Vue from 'vue';
import App from './App';
import './assets/styles/style.sass';

import { store } from './store/index';

new Vue({
  el: '#app',
  store,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js